import HistoryComponent from '@components/history/historyComponent';
import TicketService from '@services/Ticket';
import { Row } from 'antd';
import React from 'react';
import Ticket from 'src/interfaces/qafs/ticket';

import Page from '../components/Page';
import I18n from '../i18n';
import AppContext from '../services/Context';
import styled from '../styled-components';

type PropType = {};
type StateType = {
    isLoading: boolean;
    ticketAmount: number;
    ticketData: Ticket[];
    curOffset?: string;
    filteredTicketData: Ticket[];

    pickerValue?: any;
    statusWanted?: number;
    startDate?: number;
    endDate?: number;
    datesUsed: any[]
};

class History extends React.Component<PropType, StateType> {

    private idUnit: string = "";
    private _service: TicketService = new TicketService();
    state = {
        isLoading: true,
        ticketAmount: 0,
        ticketData: [],
        curOffset: undefined,
        filteredTicketData: [],
        search: undefined,
        statusWanted: undefined,
        startDate: undefined,
        endDate: undefined,
        datesUsed: [],
        pickerValue: undefined
    };

    setUnit (unitId: string) {
        //console.log(unitId);
        this.idUnit = unitId;
    }

    componentDidMount () {
        this.getHistory(true, true);
    }

    getHistory = async (reset: boolean, showLoading: boolean) => {
        this.setState({ isLoading: showLoading });
        if (reset) {
            this.setState({
                curOffset: undefined,
                ticketData: [],
                ticketAmount: 0,
            });
        }

        //TicketStatus.CLOSED
        try {
            const data = await this._service.me(this.idUnit, { limit: 10, offset: this.state.curOffset });

            let newTicketData: Ticket[] = [];

            if (!reset) {
                newTicketData = this.state.ticketData || [];
            }
            newTicketData = newTicketData.concat(data.items);

            this.setState({
                isLoading: false,
                ticketAmount: data.count,
                ticketData: newTicketData,
                curOffset: data.offset
            });
        } catch (error) {
            console.warn(error);
            this.setState({
                isLoading: false,
            });
        }
    };

    loadMoreHistory (callback?: any) {
        //console.log("Loading More Data");
        this.getHistory(false, false);
    }

    searchData = async (event: any) => {
        this.filterByDate();
    }

    setNewDates = async (dates: any[]) => {
        this.setState({
            datesUsed: dates,
            startDate: dates[0],
            endDate: dates[1],
            pickerValue: dates,
        })
    }

    filterByDate = async () => {
        //debugger;
        try {
            await this.getHistory(true, true);
        }
        catch (err) {
            console.log(err)
        }
    }

    filterData = async (status: any) => {
        if (status !== this.state.statusWanted) {
            this.setState({
                isLoading: true,
                statusWanted: status
            })
            try {
                this.getHistory(true, true);
            }
            catch (err) {
                console.log(err);
            }
        }
    }

    resetFilters = async () => {
        this.setState({
            datesUsed: [],
            pickerValue: undefined,
            startDate: undefined,
            endDate: undefined,
            statusWanted: undefined,
            isLoading: true,
        })

        this.setNewDates([]);

        try {
            await this.getHistory(true, true);
        }
        catch (err) {
            console.log(err)
        }
    }

    isUsingSomeFilter () {
        let usingStatus = this.state.statusWanted !== undefined;
        let usingDates = this.state.datesUsed.length > 0;
        return (usingStatus || usingDates);
    }

    render () {
        const {
            isLoading,
            ticketData,
            curOffset
        } = this.state;

        return (
            <Page>
                <AppContext.Consumer>
                    {({ locale, theme, activeUnitId }) => (
                        <Row>
                            {
                                this.idUnit === undefined || this.idUnit.length === 0 &&
                                this.setUnit(activeUnitId)
                            }

                            {
                                (isLoading) &&
                                <div className="goepik-component-padding">
                                    <h2>{I18n.l('common.loadingTable')}</h2>
                                </div>
                            }
                            {
                                (!isLoading) &&
                                <Row>
                                    <HistoryComponent
                                        data={ticketData}
                                        hasMoreWorkflowItens={(curOffset != undefined)}
                                        loadMoreTickets={() => this.loadMoreHistory()}
                                        refreshDataEvent={() => this.getHistory(true, true)}
                                    />
                                </Row>
                            }
                        </Row>
                    )}
                </AppContext.Consumer>
            </Page>
        );
    }
}

export default History;
